import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../common/CmnContext';


export function SaleListDetailExplane(props: any) {

  const sale = props.sale;

  const isPc = useContext(cmnContext).isPc;

  // http:// https:// から始まるものはリンクにする
  const renderWithLinks = (text: string) => {
    const parts = text.split(/(https?:\/\/[^\s]+)/g);
    return parts.map((part, i) =>
      /^https?:\/\//.test(part)
        ? <a key={i} href={part} rel="noopener noreferrer" style={{color: '#0066cc', textDecoration: 'underline'}}>{part}</a>
        : part
    );
  };

  return (
    <p style={{
      fontSize: isPc? '100%' : '90%',
      margin: '30px 0',
      whiteSpace: 'pre-line',
    }}>{sale?.explane ? renderWithLinks(sale.explane) : null}</p>
  );
}